module.exports = __webpack_public_path__ + "img/product_25.df31d8b.webp";